module.exports = __webpack_public_path__ + "static/media/autokar3 (8).8d2b7cfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar3 (8).jpg
// module id = 864
// module chunks = 0